<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<p class="chaptitle1"><a id="ack"></a>ACKNOWLEDGMENTS</p>
<p style="text-align:center; margin-top:2pc"></p>
<p class="text"><a id="page_xi"></a><i>A big thank you to all those who contributed</i> stories to this collection, especially Kathy Cordova, for roping in all her writer friends and helping spread the word. Our friendship is new, but precious nonetheless.</p>
<p class="textindent">A bow of appreciation to my dear friend Mary Beth Sammons for writerly support over the years and permission to excerpt from her wonderful book <i>Gifts with Heart</i>, copyright © 2002 by Mary Beth Sammons. Reprinted by permission of Conari Press.</p>
<p class="textindent">Mega-thanks to my editor, Jan Johnson, who had the idea for this book in the first place.</p>
<p class="textindent">Thanks to Annette Madden for typing assistance and friendship inspiration.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_acknowledgments.vue?159d1cd2